export const EVENT_GENRE_OPTIONS = [
  'AFROBEATS',
  'amapiano',
  'ANISON',
  'BAND',
  'CLASSIC',
  'DANCEHALL',
  'DJ',
  'EDM',
  'FUNK',
  'HIPHOP',
  'HOUSE',
  'IDOL',
  'JAZZ',
  'POPS',
  'REGGAE',
  'R&B',
  'ROCK',
  'SOUL',
  'TECHNO',
  'TRANCE',
  'SPORTS観戦',
  'eスポーツ',
  'お笑い',
  'コスプレ',
  'サッカー',
  'トークイベント',
  'バスケットボール',
  'バレーボール',
  '交流会',
  '格闘技',
  '舞台',
  '野球',
];
